import { styled } from 'twin.macro';
import { LinkProps } from '.';
import { getFontWeightStyles } from './utils';

export default styled.a<LinkProps>`
    ${({ variant }) => getFontWeightStyles(variant)};
`;
